import type { SxProps, Theme } from '@mui/material/styles';

export const hcpCardStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 2,
		px: 2,
		py: 0.75,
		width: '100%',
		color: 'text.fadedPrimary',
		textDecoration: 'none',
		cursor: 'pointer',

		'&:focus': {
			backgroundColor: 'primary.hover',
			outline: 'none'
		},
		'&:hover': {
			backgroundColor: 'primary.hover'
		}
	} as SxProps<Theme>,

	textRow: {
		display: 'flex',
		flexDirection: 'row'
	},

	affiliationSeparator: {
		color: 'text.secondary'
	},

	mainContentContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
		flex: 1,
		minWidth: 0
	} as SxProps<Theme>,

	name: {
		fontSize: 'clamp(1rem, 1rem, 1.5rem)',
		lineHeight: '150%',
		letterSpacing: '.15px',
		fontWeight: 700,
		p: 0,
		m: 0
	},

	specialtyAndType: {
		fontSize: '.875rem',
		fontWeight: 400,
		lineHeight: '140%'
	},

	iconContainer: {
		backgroundColor: 'primary.lighter',
		width: 40,
		height: 40,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: '0 0 auto'
	},

	chipRow: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 1,
		alignItems: 'center',
		verticalAlign: 'middle',
		fontWeight: 400,
		flexShrink: 0,
		my: 0.5
	}
};
